<template>
	<div class="tutorial-gift">
		<div class="tutorial-gift__header">
			<img
				src="@/assets/images/tutorial/gift-bg.png"
				alt=""
				class="tutorial-gift__bg"
			/>
			<img
				src="@/assets/images/tutorial/gift-pattern.png"
				alt=""
				class="tutorial-gift__pattern"
			/>
			<img
				src="@/assets/images/tutorial/gift-logo.svg"
				alt="Luca Education"
				class="tutorial-gift__logo"
			/>
		</div>
		<div class="tutorial-gift__body">
			<div class="tutorial-gift__content">
				<div class="tutorial-gift__title">Quà tặng dành cho bạn!</div>
				<div class="tutorial-gift__text">
					Bạn đang được kích hoạt
					<span class="font-semibold">14 ngày dùng thử miễn phí</span>
					trọn bộ tính năng trả phí của Luca Education. Sau 14 ngày, tài
					khoản sẽ tự động chuyển sang
					<span class="font-semibold">Gói Cộng đồng (Miễn phí)</span>
					mà không phát sinh bất kỳ chi phí nào.
				</div>
			</div>
			<button
				type="button"
				class="tutorial-gift__button"
				@click="$emit('start')"
			>
				Bắt đầu trải nghiệm
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TutorialGiftModal',
	emits: ['start'],
};
</script>

<style scoped>
.tutorial-gift {
	width: 600px;
	max-width: calc(100vw - 32px);
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.1), 0 20px 24px rgba(20, 37, 63, 0.06);
}
.tutorial-gift__header {
	position: relative;
	height: 236px;
	overflow: hidden;
}
.tutorial-gift__bg {
	position: absolute;
	top: 2px;
	left: 50%;
	width: 600px;
	height: 546px;
	max-width: none;
	transform: translateX(-50%) scaleX(-1);
}
.tutorial-gift__pattern {
	position: absolute;
	top: 48px;
	left: calc(50% - 84.35px);
	width: 168.71px;
	height: 140.74px;
	max-width: none;
	object-fit: cover;
}
.tutorial-gift__logo {
	position: absolute;
	top: 106.88px;
	left: calc(50% - 73.44px);
	width: 147.21px;
	height: 75.67px;
	max-width: none;
}
.tutorial-gift__body {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 40px;
	padding: 40px;
	background: #fff;
}
.tutorial-gift__content {
	display: flex;
	flex-direction: column;
	gap: 24px;
	text-align: center;
	color: #344256;
}
.tutorial-gift__title {
	font-size: 20px;
	line-height: 28px;
	font-weight: 600;
}
.tutorial-gift__text {
	font-size: 16px;
	line-height: 24px;
}
.tutorial-gift__button {
	width: 100%;
	padding: 12px 20px;
	border-radius: 4px;
	background: #f0bb4f;
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
	color: #344256;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.24), 0 3px 8px rgba(50, 50, 71, 0.05);
}
</style>
